// extracted by mini-css-extract-plugin
module.exports = {"container":"th","disabled":"uh","bgBlack":"vh","content":"wh","countdown":"xh","topCaption":"yh","topHeading":"zh","heading":"Ah","copy":"Bh"};